module.exports = "table tr.selectedRow {\n  background-color: #01d3ca !important;\n  color: #ffffff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail-manufacturer/home-main-modal-detail-manufacturer.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail-manufacturer/home-main-modal-detail-manufacturer.component.sass
// module chunks = main